import { render, staticRenderFns } from "./ConfigurationDetails.vue?vue&type=template&id=642e185c&scoped=true&"
import script from "./ConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationDetails.vue?vue&type=style&index=0&id=642e185c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642e185c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642e185c')) {
      api.createRecord('642e185c', component.options)
    } else {
      api.reload('642e185c', component.options)
    }
    module.hot.accept("./ConfigurationDetails.vue?vue&type=template&id=642e185c&scoped=true&", function () {
      api.rerender('642e185c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/configurationManager/ConfigurationDetails.vue"
export default component.exports